<template>
  <div>
    <v-card class="mt-2">
      <v-card flat>
        <v-card-title class="text-h5"> Cargar imagenes </v-card-title>
        <v-card-text>
          <v-btn @click="$refs.FileInput.click()" x-small color="primary"
            >Seleccionar imagen</v-btn
          >
          <input
            ref="FileInput"
            type="file"
            style="display: none"
            accept="image/png, image/jpeg"
            @change="onFileSelect"
          />

          <vue-cropper
            v-show="imgLoading"
            preview=".preview"
            ref="cropper"
            :src="selectedFile"
            :autoCrop="false"
          ></vue-cropper>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="
              showModal = false;
              imgLoading = false;
            "
          >
            Cancelar
          </v-btn>
          <v-btn
            :loading="loaderImage"
            :disabled="loaderImage"
            color="green darken-1"
            text
            @click="saveImage()"
          >
            Subir foto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "GaleriaEditorWpp",
  components: { VueCropper },
  data: () => ({
    icons: ["mdi-trash-can"],
    imageArray: [],
    imageSelected: null,
    selectingImage: false,

    transparent: "rgba(255, 255, 255, 0)",
    showModal: false,
    imgLoading: false,
    selectedFile: "",
    loaderImage: null,
    mime_type: "",
    cropedImage: "",

    showDialog: false,
    selectedImage: null,
    loadIndex: 0,
  }),
  methods: {
    async handleClickBoard(url) {
      let textToCopy = url;
      try {
        await navigator.clipboard.writeText(textToCopy);
      } catch (err) {
        console.error("Error al copiar: ", err);
      }
    },

    onFileSelect(e) {
      const file = e.target.files[0];

      // Validar si el archivo es PNG o JPG
      if (!file || (file.type !== "image/png" && file.type !== "image/jpeg")) {
        alert("Solo se permiten archivos PNG y JPG.");
        e.target.value = ""; // Limpiar el input si el archivo no es válido
        return;
      }

      this.mime_type = file.type;

      if (typeof FileReader === "function") {
        this.showModal = true;
        const reader = new FileReader();

        reader.onload = (event) => {
          this.selectedFile = event.target.result;
          this.imgLoading = true;
          this.$refs.cropper.replace(this.selectedFile);
        };

        reader.readAsDataURL(file);
      } else {
        alert("Lo siento, tu navegador no soporta la API de FileReader.");
      }
    },
    saveImage() {
      this.loaderImage = true;
      if (!this.selectedFile) {
        this.$swal({ title: "Error", text: "Favor de ingresar una imagen" });
        this.loaderImage = false;
      } else {
        this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const formData = new FormData();
          formData.append("Tenant", this.$store.getters.getFirebaseApp.tenant);
          formData.append("Multimedia", blob);

          // Generar URL local a partir del Blob
          const localUrl = URL.createObjectURL(blob);

          this.$store.getters.getFirebaseApp.fba
            .callForm("MKT-Multimedia-subirMultimedia", formData, {
              "Content-Type": "multipart/form-data",
            })
            .then((result) => {
              if (result.data.ok) {
                // console.log("data", result.data);
                this.$emit("autoImage", result.data.data, localUrl);
                this.loaderImage = false;
                this.showModal = false;
              }
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
              this.loaderImage = false;
            });
        }, this.mime_type);
      }
    },
    // zoom(percent) {
    //   this.$refs.cropper.relativeZoom(percent);
    // },
    // rotate(deg) {
    //   this.$refs.cropper.rotate(deg);
    // },
  },
};
</script>
